import React, {useCallback, useState} from 'react';
import SectionPopup from './SectionPopup.js';
import MyBonusList from './MyBonusList.js';

// Popup s pozvánkami a bonusy konkrétního uživatele (monitoring). Obsah je stejný
// jako v sekci /mybonus/:targetUsrId (sdílená komponenta MyBonusList).
export default function UserBonusPopup({show, close, user, usrInfo, onNavigate}) {
	const [loading, setLoading] = useState(false);
	const userName = user?.NAME || `${user?.LASTNAME || ''} ${user?.FIRSTNAME || ''}`.trim();

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<SectionPopup show={show} close={close} title={`Pozvánky a bonusy${userName !== '' ? ` – ${userName}` : ''}`} loading={loading} className="user-bonus-popup" onNavigate={onNavigate}>
			<div className="mybonus-page mybonus-page--popup">
				<MyBonusList usrInfo={usrInfo} targetUsrId={user?.ID || 0} variant="popup" onLoadingChange={handleLoadingChange} />
			</div>
		</SectionPopup>
	);
}
